import styled from 'styled-components';

export const SCDiv = styled.div``;

export const SCViewDetailsWrapper = styled.div`
    white-space-collapse: preserve;
    width: 100%;
`;
